<template>
  <administrators-list
    v-if="selectedCustomer.id"
    :tier="tierType"
    :id="selectedCustomer.id"
  />
</template>
<script>
import { mapActions, mapGetters } from "vuex";

import AdministratorsList from "@/views/Common/Administrators/index.vue";

import { TIER } from "@/constants";

export default {
  components: {
    AdministratorsList,
  },
  data() {
    return {
      tierType: TIER.domainGroups,
    };
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
  },
  computed: {
    ...mapGetters("authentication", ["selectedCustomer"]),
  },
  created() {
    this.setPageTitle(this.$t("Administrators"));
    this.setPageSubtitle([]);
  },
};
</script>
